const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Swap image for the products page gallery
 */
const ImageSwap = {

    init() { 

        $('.thumbnail-image--item').on('click', function() {

            var dataImage = $('img', this).attr("data-large-image");

            if(!$(this).hasClass('image--selected')) {
                $('.thumbnail-image--item.image--selected').removeClass('image--selected');
                $(this).addClass('image--selected');
                $('#main-image img').attr("src", dataImage );

            } 
        return false;
        });
    }

    

};

export default ImageSwap;